<ng-template #pinFormBody>
  <div class="dialog-header">
    <div class="header-icon-wrapper">
      <i class="fas fa-key" aria-hidden="true"></i>
    </div>
    <h3 id="tf-pin-dialog-title">{{ title }}</h3>
    <p class="dialog-header-subtitle">Token: <strong>{{ pinData.tokenLabel }}</strong> (Slot {{ pinData.slotId }})</p>
  </div>

  <div class="auth-form-content">
    <!-- Consultar: un solo campo PIN -->
    <ng-container *ngIf="isConsultar">
      <label for="tf-pin-input" class="label-document">PIN</label>
      <div class="auth-input-wrap auth-input-wrap-password">
        <input
          type="text"
          id="tf-pin-input"
          [(ngModel)]="pin"
          name="pin"
          class="auth-input"
          [class.auth-input-masked]="!pinVisible"
          placeholder="Ingrese el PIN (4–16 caracteres)"
          autocomplete="off"
          maxlength="16"
          aria-required="true"
          cdkFocusInitial
          [attr.aria-label]="pinVisible ? 'PIN visible' : 'PIN oculto'" />
        <button
          type="button"
          class="password-toggle-btn"
          (mousedown)="pinVisible = true"
          (mouseup)="pinVisible = false"
          (mouseleave)="pinVisible = false"
          (touchstart)="pinVisible = true; $event.preventDefault()"
          (touchend)="pinVisible = false"
          (touchcancel)="pinVisible = false"
          (pointerdown)="pinVisible = true"
          (pointerup)="pinVisible = false"
          (pointercancel)="pinVisible = false"
          tabindex="0"
          [attr.aria-label]="'Mantenga pulsado para ver el PIN'">
          <i class="fas fa-eye" aria-hidden="true"></i>
        </button>
      </div>
    </ng-container>

    <!-- Restore paso 1: PIN actual para verificar -->
    <ng-container *ngIf="isRestoreStep1">
      <p class="step-hint">Introduzca el PIN actual del token para poder restablecerlo.</p>
      <label for="tf-current-pin-input" class="label-document">PIN actual</label>
      <div class="auth-input-wrap auth-input-wrap-password">
        <input
          type="text"
          id="tf-current-pin-input"
          [(ngModel)]="pin"
          name="pin"
          class="auth-input"
          [class.auth-input-masked]="!pinVisible"
          placeholder="PIN actual (4–16 caracteres)"
          autocomplete="current-password"
          maxlength="16"
          aria-required="true"
          cdkFocusInitial
          [attr.aria-label]="pinVisible ? 'PIN visible' : 'PIN oculto'" />
        <button
          type="button"
          class="password-toggle-btn"
          (mousedown)="pinVisible = true"
          (mouseup)="pinVisible = false"
          (mouseleave)="pinVisible = false"
          (touchstart)="pinVisible = true; $event.preventDefault()"
          (touchend)="pinVisible = false"
          (touchcancel)="pinVisible = false"
          (pointerdown)="pinVisible = true"
          (pointerup)="pinVisible = false"
          (pointercancel)="pinVisible = false"
          tabindex="0"
          [attr.aria-label]="'Mantenga pulsado para ver el PIN'">
          <i class="fas fa-eye" aria-hidden="true"></i>
        </button>
      </div>
    </ng-container>

    <!-- Restore paso 2 o restoreAfterOtp: Nuevo PIN + Confirmar PIN -->
    <ng-container *ngIf="isRestoreStep2">
      <button
        type="button"
        class="back-link"
        *ngIf="isRestore && !isRestoreAfterOtp"
        (click)="backToStep1()"
        [disabled]="validatingPin"
        aria-label="Volver a introducir PIN actual">
        <i class="fas fa-arrow-left"></i> Cambiar PIN actual
      </button>
      <p class="step-hint" *ngIf="isRestoreAfterOtp">Ingrese y confirme el nuevo PIN para su token.</p>
      <label for="tf-new-pin-input" class="label-document">Nuevo PIN de usuario</label>
      <div class="auth-input-wrap auth-input-wrap-password">
        <input
          type="text"
          id="tf-new-pin-input"
          [(ngModel)]="newPin"
          name="newPin"
          class="auth-input"
          [class.auth-input-masked]="!newPinVisible"
          placeholder="Nuevo PIN (4–16 caracteres)"
          autocomplete="new-password"
          maxlength="16"
          aria-required="true"
          cdkFocusInitial
          [attr.aria-label]="newPinVisible ? 'Nuevo PIN visible' : 'Nuevo PIN oculto'" />
        <button
          type="button"
          class="password-toggle-btn"
          (mousedown)="newPinVisible = true"
          (mouseup)="newPinVisible = false"
          (mouseleave)="newPinVisible = false"
          (touchstart)="newPinVisible = true; $event.preventDefault()"
          (touchend)="newPinVisible = false"
          (touchcancel)="newPinVisible = false"
          (pointerdown)="newPinVisible = true"
          (pointerup)="newPinVisible = false"
          (pointercancel)="newPinVisible = false"
          tabindex="0"
          [attr.aria-label]="'Mantenga pulsado para ver el PIN'">
          <i class="fas fa-eye" aria-hidden="true"></i>
        </button>
      </div>

      <div
        *ngIf="newPin.length"
        class="pin-strength-block"
        role="status"
        aria-live="polite"
        [attr.aria-label]="newPinStrengthLabel || 'Análisis del nuevo PIN'">
        <div class="pin-strength-track" aria-hidden="true">
          <div
            class="pin-strength-fill"
            [class.pin-strength-fill--weak]="newPinStrengthClass === 'weak'"
            [class.pin-strength-fill--fair]="newPinStrengthClass === 'fair'"
            [class.pin-strength-fill--good]="newPinStrengthClass === 'good'"
            [class.pin-strength-fill--strong]="newPinStrengthClass === 'strong'"
            [style.width.%]="newPinStrengthPercent"></div>
        </div>
        <p class="pin-strength-label" *ngIf="newPinStrengthLabel">{{ newPinStrengthLabel }}</p>
        <ul class="pin-req-list" aria-label="Recomendaciones para un PIN más robusto">
          <li [class.ok]="newPinHasMinLength">Mín. 4 caracteres (obligatorio)</li>
          <li [class.ok]="newPinHasLength8">8 o más caracteres</li>
          <li [class.ok]="newPinHasDigit">Incluye número</li>
          <li [class.ok]="newPinHasLetter">Incluye letra</li>
          <li [class.ok]="newPinHasMixedCase">Mayúsculas y minúsculas</li>
          <li [class.ok]="newPinHasSpecial">Carácter especial</li>
        </ul>
        <p class="pin-strength-hint">
          La barra es orientativa; su token puede aceptar un PIN numérico corto si así lo permite la política del dispositivo.
        </p>
      </div>

      <label for="tf-confirm-pin-input" class="label-document">Confirmar PIN</label>
      <div class="auth-input-wrap auth-input-wrap-password">
        <input
          type="text"
          id="tf-confirm-pin-input"
          [(ngModel)]="confirmPin"
          name="confirmPin"
          class="auth-input"
          [class.auth-input-masked]="!confirmPinVisible"
          placeholder="Repita el nuevo PIN"
          autocomplete="new-password"
          maxlength="16"
          aria-required="true"
          [attr.aria-label]="confirmPinVisible ? 'Confirmar PIN visible' : 'Confirmar PIN oculto'" />
        <button
          type="button"
          class="password-toggle-btn"
          (mousedown)="confirmPinVisible = true"
          (mouseup)="confirmPinVisible = false"
          (mouseleave)="confirmPinVisible = false"
          (touchstart)="confirmPinVisible = true; $event.preventDefault()"
          (touchend)="confirmPinVisible = false"
          (touchcancel)="confirmPinVisible = false"
          (pointerdown)="confirmPinVisible = true"
          (pointerup)="confirmPinVisible = false"
          (pointercancel)="confirmPinVisible = false"
          tabindex="0"
          [attr.aria-label]="'Mantenga pulsado para ver el PIN'">
          <i class="fas fa-eye" aria-hidden="true"></i>
        </button>
      </div>

      <p class="pin-match-line pin-match-line--ok" *ngIf="pinsMatchHint === 'match'">
        <i class="fas fa-check-circle" aria-hidden="true"></i> Los PIN coinciden
      </p>
      <p class="pin-match-line pin-match-line--warn" *ngIf="pinsMatchHint === 'mismatch'">
        <i class="fas fa-exclamation-circle" aria-hidden="true"></i> Los PIN no coinciden
      </p>
    </ng-container>

    <p class="validation-message" *ngIf="validationMessage">{{ validationMessage }}</p>

    <div class="button-container">
      <button type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="validatingPin" [attr.aria-disabled]="validatingPin" aria-label="Cancelar">
        Cancelar
      </button>
      <button
        type="button"
        class="btn btn-primary"
        (click)="confirm()"
        [disabled]="confirmDisabled"
        [attr.aria-label]="confirmDisabled ? 'Complete los campos para continuar' : confirmLabel"
        [attr.aria-disabled]="confirmDisabled">
        <span *ngIf="!validatingPin">{{ confirmLabel }}</span>
        <span *ngIf="validatingPin">Comprobando…</span>
      </button>
    </div>
  </div>
</ng-template>

<div *ngIf="!embedded" mat-dialog-content role="dialog" aria-modal="true" [attr.aria-labelledby]="'tf-pin-dialog-title'">
  <ng-container *ngTemplateOutlet="pinFormBody"></ng-container>
</div>
<div *ngIf="embedded" class="tf-admin-step-panel tf-pin-dialog-embedded" role="region" [attr.aria-labelledby]="'tf-pin-dialog-title'">
  <ng-container *ngTemplateOutlet="pinFormBody"></ng-container>
</div>
